import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = '', y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = '' }) {
  return (
    <p
      className={`font-mono text-[11px] sm:text-xs font-semibold uppercase tracking-[0.35em] text-nofina-red ${className}`}
    >
      {children}
    </p>
  );
}
